import { useMemo } from 'react';
import { formatUnits } from 'ethers/lib/utils';
import { Campaign } from '@app/hooks/merkl/useMerklCampaigns';
import { MetromCampaign } from '@app/hooks/metrom/useMetromCampaigns';
import { differenceInCalendarDays } from 'date-fns';

export function useMergedMarketMakerRewards(
  marketMakerCampaign:
    | {
        merkl: Array<Campaign & { amountUSD: number }>;
        metrom: Array<MetromCampaign & { amountUSD: number }>;
      }
    | undefined,
  vaultAddress: string | undefined
) {
  return useMemo(() => {
    const merkl =
      marketMakerCampaign?.merkl
        .filter(m => {
          if (vaultAddress) {
            return m.campaignParameters.whitelist
              .map(w => w.toLowerCase())
              .includes(vaultAddress.toLowerCase());
          }

          return m.campaignParameters.whitelist.length === 0;
        })
        .map(m => {
          const daysDifference = differenceInCalendarDays(
            new Date(m.startTimestamp * 1000),
            new Date(m.endTimestamp * 1000)
          );

          return {
            amount: formatUnits(
              m.amount,
              m.campaignParameters.decimalsRewardToken
            ),
            symbol: m.campaignParameters.symbolRewardToken,
            duration: Math.abs(daysDifference)
          };
        }) ?? [];
    const metrom =
      marketMakerCampaign?.metrom.map(m => {
        const daysDifference = differenceInCalendarDays(
          new Date(m.from * 1000),
          new Date(m.to * 1000)
        );

        return {
          amount: formatUnits(m.rewards[0].amount, m.rewards[0].decimals),
          symbol: m.rewards[0].symbol,
          duration: Math.abs(daysDifference)
        };
      }) ?? [];

    return [...metrom, ...merkl];
  }, [marketMakerCampaign?.merkl, marketMakerCampaign?.metrom, vaultAddress]);
}
